import { RegEdSubmissionFailureReason } from '@Queries/RegEdCompliance';

export const getRegEdFailureText = (failureReason?: RegEdSubmissionFailureReason | null): string | null => {
	switch (failureReason) {
		case RegEdSubmissionFailureReason.ProviderRejected:
			return 'RegEd did not accept this filing, so it never reached a reviewer. Edit it and send it for review again.';
		case RegEdSubmissionFailureReason.ProviderUnauthorized:
			return 'RegEd refused your access to this filing, so it never reached a reviewer. An administrator needs to check your RegEd user mapping and its permissions before you send it again.';
		case RegEdSubmissionFailureReason.SubmitterNotMapped:
			return "You don't have a RegEd Rep Code, so this never reached a reviewer. Add it under Integrations → RegEd, then send it again.";
		case RegEdSubmissionFailureReason.NotSubmitted:
			return "This is scheduled, but its compliance answers weren't accepted, so nothing was filed. It won't send until you answer the compliance questions.";
		default:
			return null;
	}
};
